// Shared design tokens and layout constants for the ai-chat panel.
export const D = {
	bg: '#ffffff',
	surface: '#f8f7fb',
	surface2: '#f0ecfa',
	border: '#e9e9e9',
	borderFocus: '#6E0FEB',
	textPrimary: '#2e2541',
	textSecondary: '#535353',
	textMuted: '#8c8c8c',
	textDisabled: '#acacb9',
	accent: '#392664',
	accentMid: '#6E0FEB',
	accentHover: '#f0ecfa',
	userBubble: '#0004db',
	userBubbleBorder: 'transparent',
	assistantBubble: '#fcfbfd',
	assistantBubbleBorder: '#d3d3df',
	inputBg: '#ffffff',
	inputBorder: '#d3d3df',
	stepDoneBg: '#f0fdf4',
	stepDoneBorder: '#86efac',
	stepDoneText: '#15803d',
	stepActiveBg: '#f0ecfa',
	stepActiveBorder: '#c4b5fd',
	stepActiveText: '#6d28d9',
	stepIdleBg: '#f9fafb',
	stepIdleBorder: '#e5e7eb',
	stepIdleText: '#6b7280',
	stepIdleDot: '#d1d5db',
	errorBg: '#fef2f2',
	errorBorder: '#fca5a5',
	errorText: '#e23f3f',
	// sky/sys colour overrides used by AgentDrawer and newer ai-chat components
	v2: {
		textPrimary: '#232334',
		textSecondary: '#6b6d7b',
		borderEnabled: '#6b6d7b',
		accent: '#0004db',
		surfaceHover: '#f5f3f9',
		iconInactive: '#9898a8',
		btnInactiveBg: '#e8e8f0',
		statusGreen: '#148f6a',
		statusAmber: '#e57700',
		statusRed: '#db0900',
	},
};

export const TRUNCATE_AT = 1200;
export const PREVIEW_CHARS = 800;
export const MIN_WIDTH = 340;
export const MAX_WIDTH = 860;
export const DEFAULT_WIDTH = 560;
export const CARD_BOTTOM = 80;
